import CustomSelect from './CustomSelect';

interface MultiSelectInputProps {
  label: string;
  value: string[];
  error?: string;
  onChange: (value: string[]) => void;
  disabled?: boolean;
  isMandatory?: boolean;
  options: string[];
}

function MultiSelectInput({
  label,
  value,
  error,
  onChange,
  disabled = false,
  isMandatory = false,
  options,
}: MultiSelectInputProps) {
  return (
    <div className="d-block w-100 subscribe__property__content__customfield">
      <div className="subscribe__property__content__label">
        {label}
        {isMandatory && <span className="text-danger"> *</span>}
      </div>
      <CustomSelect
        value={value || []}
        options={options}
        placeholder="Select options..."
        disabled={disabled}
        isInvalid={!!error}
        onChange={newValue => onChange(newValue as string[])}
        multiSelect={true}
        searchable={false}
      />
      {error && (
        <div className="subscribe__property__content__error">{error}</div>
      )}
    </div>
  );
}

export default MultiSelectInput;
